import { useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { getTickerBars } from '../api/marketData'
import { getQuote } from '../api/trading'
import { useAuthStore } from '../auth/useAuthStore'

/**
 * Warm the ticker page's queries on hover/focus of a ticker link so the
 * chart and quote paint instantly on navigation. Keys must mirror the
 * initial queries in TickerPriceChart (interval '1m' → range '1D') and
 * QuoteCard.
 */
export function usePrefetchTicker() {
  const qc = useQueryClient()
  const accountId = useAuthStore((s) => s.accountId)
  return useCallback(
    (symbol: string | null | undefined) => {
      if (!symbol) return
      const upper = symbol.toUpperCase()
      void qc.prefetchQuery({
        queryKey: ['ticker-bars', upper, '1D', '1m'],
        queryFn: () => getTickerBars(upper, '1D', '1m'),
        staleTime: 5 * 60_000,
      })
      if (accountId) {
        void qc.prefetchQuery({
          queryKey: ['quote', upper, accountId],
          queryFn: () => getQuote(upper),
          staleTime: 5_000,
        })
      }
    },
    [qc, accountId],
  )
}
